import { Box, Typography } from '@mui/material';
import { PazaramaOrderProduct } from '../../../interfaces/Pazarama/PazaramaOrderProduct';
import { sharedColors, sharedStyles } from '../../../utils/Style';
import { PazaramaOrder } from '../../../interfaces/Pazarama/PazaramaOrder';

interface ProductRowProps {
  product: PazaramaOrderProduct;
}

const ProductRow = (props: ProductRowProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography sx={{ ...sharedStyles.body2, fontWeight: 'bold' }}>
        {props.product.productName}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.2,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={sharedStyles.body2}>Barkod:</Typography>
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.product.barcode}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.2,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={sharedStyles.body2}>Miktar:</Typography>
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.product.quantity.toString()}
        </Typography>
      </Box>
    </Box>
  );
};

interface PazaramaProductsCellProps {
  order: PazaramaOrder;
}

export const PazaramaProductsCell = (props: PazaramaProductsCellProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        maxHeight: 250,
        overflowY: 'auto',
      }}
    >
      {props.order.products.map((product, i) => (
        <ProductRow key={i} product={product} />
      ))}
    </Box>
  );
};
